export default __webpack_public_path__ + "static/media/MasLaFont.4cfa2af6.jpg";